module.exports = __webpack_public_path__ + "img/img02.cec7b5ea.png";